import React from 'react';
import { matchPath, NavLink, useLocation } from 'react-router-dom';

import { Label } from '@atlas/ui';

export default function ProfileTabs({ parentPath, tabs }) {
  const { pathname } = useLocation();

  return tabs.map(({ link, name }) => {
    const to = link ? `${parentPath}/${link}` : parentPath || link;
    // empty-link tabs point at the parent path (e.g. the combined bonus feed); match them exactly so they are not flagged active when a sibling literal-segment tab is open.
    const active = !!matchPath(pathname, { exact: !link, path: to });

    const handleLinkClick = e => {
      if (active) {
        e.preventDefault();
      }
    };

    return (
      <NavLink className="tab-link" exact={!link} key={link} onClick={handleLinkClick} to={to}>
        <Label message={name} />
      </NavLink>
    );
  });
}
